<template>
  <LayoutSearchFieldVertical
    display-variant="list"
  >
    <div class="facet-buttons facet-mobile-grid">
      <button
        class="fb-button"
        v-for="(count, key) in counts"
        :class="{
          'is-0': count === 0,
          'is-selected': isSelected('+' + key),
        }"
        @click="select(key)"
        :key="key"
      >
        <span class="fb-label">{{ displayValue(key) }}</span>
        <span class="fb-count" :title="num(count)">{{ num(count) }}</span>
      </button>
      <div class="no-facet" v-if="isEmpty(counts)">
        {{ lss('該当なし', 'No Hit') }}
      </div>
    </div>
  </LayoutSearchFieldVertical>
</template>
<script lang="ts" setup>
import { useSearchFieldBase } from '~/components/search/search-field/useBaseSearchField'
import type { SearchFieldBaseProps } from '~/components/search/search-field/useBaseSearchField'

const { ls, lss, num, lc } = useI18n()
const dataStore = useDataStore()

interface Props extends SearchFieldBaseProps {
  displayFunction?: (code: string) => string
}
const props = withDefaults(defineProps<Props>(), {
})

const { facet } = useSearchFieldBase(props)

const select = (key: string) => {
  key = '+' + key
  if (isSelected(key)) {
    props.ss.removeFilter(props.field.key, [key])
  } else {
    props.ss.addFilter(props.field.key, [key])
  }
}

const isSelected = (key: string) => {
  return props.ss.state.filter[props.field.key]?.includes(key)
}

const counts = computed(() => {
  if (!facet.value) return {}
  const keys = Object.keys(facet.value.counts).sort(
      (a, b) => facet.value.counts[b] - facet.value.counts[a]
  )
  let obj = {}
  keys.forEach((key) => {
    obj[key] = facet.value.counts[key]
  })
  return obj
})

const displayValue = (value: string) => {
  if (props.displayFunction) return props.displayFunction(value)
  const def = PUBLICATION_LEVEL_DEF.c[value]
  if (def?.l) return ls(def.l)
  if (props.field.codeKey) {
    const code = dataStore.code(props.field.codeKey)
    if (code) return lc(code, value)
  }
  return value
}
</script>
